module.exports = __webpack_public_path__ + "img/img_cs_img3.4fe60e2d.png";